// extracted by mini-css-extract-plugin
export var root = "title-module--root--9926e";